<div class="fn-tag-container">
  <ng-select
    [addTag]="addTagFn"
    [items] = "itemTags"
    [clearOnBackspace]="isClearOnBackspace"
    bindLabel="name"
    multiple="true"
    [(ngModel)]="selectedTags"
    [placeholder]="placeholder"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (add)="addItem($event)"
    (remove) = "removeItem($event)"
    [appendTo]="appendTo"
    (change) = "addAction()"
    (onOpen)="onOpen()"
    [name] = "tagName"
    [hideSelected]="hideSelected"
    [disabled]="isDisabled"
    >
    @if (isShowCustomLabel) {
      <ng-template  ng-multi-label-tmp >
        @if (fnTagMap.isShowPlaceHolder) {
          <span class="cutom-select-placeholder "> {{ placeholder }}</span>
        }
      </ng-template>
    }
  </ng-select>
</div>
@if (showLabel && selectedTags && selectedTags.length > 0) {
  <fn-scrollbar
    [options]="{ scrollbarMinSize: 20, autoHide: false }"
    [position]="'right'"
    class="fn-tag-scroll"
    [style.maxHeight]="scrollMaxHeight"
    >
    <div>
      @for (t of selectedTags; track t) {
        <div class="fn-tag-list">
          <p class="m-0">
            @if (isShowDelete) {
              <span class="alignCross" (click)="filterTags(t)" [ngClass]="{'disable':isDisabled}"
                ><i class="fn-global-times"></i></span
                >
                }<span class="text-truncate trun-text" title="{{ t.name }}">{{
                t.name
              }}</span>
            </p>
          </div>
        }
      </div>
    </fn-scrollbar>
  }

